import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import { useHistory, useParams } from "react-router-dom";
import useSession from "Hooks/session.hook";
import { useQuery } from "Hooks/index";
import classnames from "classnames";
import { FullscreenMapEnums } from "Data/settings";
import FullscreenTrackingView from "../fullscreen-tracking-view";
import useDeliveryFullscreen from "../use-delivery-fullscreen";

// [tabActiveKey]: tabKey of delivery management setup
const SetupRedirect = {
  0: 1,
  1: 2,
};

const constructQueryParams = (params) => {
  const { redirectBack, returnType, typeOfItem } = params || {};

  let str = "/fullscreen/tracking";

  if (isEmpty(params)) return str;

  str = str.concat("?");

  // if there is a redirect back
  str = redirectBack ? str.concat(`redirect=dm_setup&`) : str;

  // note: currently, type will follow the fullscreen activeTab, so this is not needed
  // // if there is a type
  // str = typeOfItem ? str.concat(`type=${typeOfItem}&`) : str;

  // if there is a return type
  str = returnType ? str.concat(`return=${returnType}`) : str;

  // if the string ends with &, remove it
  if (str[str.length - 1] === "&") str = str.substring(0, str.length - 1);

  return str;
};

// ====================================================================
//   Moved from Parcel Tracking
// ====================================================================
const DeliveryFullscreen = ({}) => {
  const { t } = useTranslation();
  const query = useQuery();
  const { org } = useSession();
  const { id } = useParams<{ id: string }>();
  const history = useHistory();

  // helps with redirecting back to the correct previous site
  const subTab = query.get("subTab") || "4";

  // helps with directing to the correct tab
  const redirectBack = query.get("redirect") || null;
  const typeOfItem = query.get("type") || "0"; //  0 is boxes, 1 is trolleys >> dictates which screen should appear in fullscreen
  const returnType = query.get("return") || null; // if there is a need for another tab to access, use this

  const [tabActiveKey, setTabActiveKey] = useState(typeOfItem);

  const {
    globalFilterState,
    filterObj,
    setFilterObj,
    upcomingBatches,
    trolleys,
    boxesSlot,
    boxes,
    fetchUpcomingBatches,
    fetchBoxes,
    fetchSlotsData,
    fetchTrolleys,
  } = useDeliveryFullscreen();

  //  Functions
  // =================================
  const handleTabClick = (key: string) => {
    // query params
    const queryParams = {
      redirectBack: redirectBack,
      typeOfItem: typeOfItem,
      returnType: returnType,
    };

    setTabActiveKey(key);
    history.push(constructQueryParams(queryParams));
  };

  const handleAPICallsByTabs = () => {
    switch (tabActiveKey) {
      case "0":
        // fetchBoxes()
        fetchSlotsData();
        break;
      case "1":
        fetchTrolleys();
        fetchBoxes("FILLED");
        fetchUpcomingBatches();
        break;
      default:
    }
  };

  //  Use effect
  // =================================
  useEffect(() => {
    if (!isEmpty(globalFilterState) && globalFilterState?.selectedOrgIDs?.length) {
      setFilterObj({
        ...filterObj,
        companyOrgID:
          globalFilterState?.selectedOrgIDs?.length == 1
            ? globalFilterState?.selectedOrgIDs[0]
            : org._id,
      });
    }
  }, [globalFilterState]);

  const trackingProps = {
    handleAPICallsByTabs,
    tabActiveKey,
    boxes,
    upcomingBatches,
    trolleys,
    boxesSlot,
  };

  return (
    <div className="dfs-container">
      <div className={classnames("fcv-inner")}>
        <div className="fcv-header">
          <div className="fcv-h-left">
            <div className="fcv-h-title dfs-h-nav">
              <span
                className={classnames("fcv-h-option", { active: tabActiveKey === "0" })}
                onClick={() => handleTabClick("0")}
              >
                {FullscreenMapEnums.RACK}
              </span>
              <span
                className={classnames("fcv-h-option", { active: tabActiveKey === "1" })}
                onClick={() => handleTabClick("1")}
              >
                {FullscreenMapEnums.TROLLEY}
              </span>
            </div>
          </div>
          <div className="fcv-h-right">
            <div className="fcv-live-container">
              <span className="fcv-live-circle"></span>
              <span className="fcv-live-text">{t("label.live")}</span>
            </div>
            <div className="fcv-h-btn-container">
              <span
                className="fcv-custom-btn"
                onClick={() =>
                  history.push("/delivery-management/parcel-tracking?tabKey=2&subTab=4")
                }
              >
                {t("action.goToDashboard")}
              </span>
              {redirectBack === "dm_setup" && (
                <span
                  className="fcv-custom-btn"
                  onClick={() =>
                    history.push(
                      `/delivery-management/settings/assets?tabKey=${SetupRedirect?.[tabActiveKey]}`,
                    )
                  }
                >
                  {t("action.goToSetup")}
                </span>
              )}
              <span
                className="fcv-custom-btn primary"
                onClick={() => history.push("/fullscreen/configuration")}
              >
                {t("action.configureFullscreen")}
              </span>
            </div>
          </div>
        </div>
        <FullscreenTrackingView {...trackingProps} />
      </div>
    </div>
  );
};

export default DeliveryFullscreen;
